import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';

@Injectable()
export class RxJsWebSocketService {
  ws: WebSocket;

  createObservableSocket(url: string) {
    this.ws = new WebSocket(url);
    return new Observable(observer => {
      this.ws.onopen = (event) => observer.next('Connection with ' + url + ' is open');
      this.ws.onmessage = (event) => observer.next('Receiving data from ' + url + ': ' + event.data);
      this.ws.onerror = (event) => observer.error(event);
      this.ws.onclose = (event) => observer.complete();
    });
  }
  sendMessage(message: any) {
    if (this.ws) {
      console.log('Sending to the STB API: ' + JSON.stringify(message));
      this.ws.send(message);
    }
  }
  isAvailable(): boolean {
    return this.ws && this.ws.readyState === WebSocket.OPEN;
  }
}
